import requestAction from '../../utils/requestAction'
import ProductGroup from '../../models/ProductGroup';

export const upsertProductGroup = (productGroup: (ProductGroup)) =>
  requestAction('PRODUCTGROUP_UPSERT')(
    `productGroups${(productGroup as ProductGroup).id ? `/${(productGroup as ProductGroup).id}` : ''}`,
    (productGroup as ProductGroup).id ? 'PUT' : 'POST',
    productGroup
  )
